import React, { useEffect, useState } from 'react';

import { DashboardLayout, Button, Spinner } from "components";
import { chargeMethodList } from 'constants/lists';

import { 
    useAlertMessage,
    useCompanyInputs,
    useSubmission
} from "./hooks";
import { func_validation, getObjectPropertyValue_stringTrimNotEmpty, getStringUniqueId, getWindowHeight, isArrayNotEmpty } from "functions";

import "assets/scss/billingPortal/modules/recursiveBillingSetup/accountUpdate/accountUpdate.scss";
import { useOnPageExit } from 'hooks/useOnPageExit';
import { useMultiProductInputs } from './hooks/useMultiProductInputs';



export default function MultiAccountUpdate(props) {    
    // Props  
    const { 
        isEditing, 
        isAccountRecordUpdateRequesting: isLoading,
        billingSetup
    } = props;
    
    const [isFormSubmissionAttempted, setFormSubmissionStatus] = useState(false);

    const [inputWrapperID] = useState(getStringUniqueId("input-wrapper"));
    const [headerID] = useState(getStringUniqueId("header"));

    // Page Header
    let pageHeaderTitle = isEditing? "Edit Account": "Add Account";

    useEffect(() => {
        let headerEle = document.getElementById(headerID);
        let inputWrapperEle = document.getElementById(inputWrapperID);

        let headerRect = headerEle?.getBoundingClientRect();
        inputWrapperEle.style.height = (getWindowHeight() - headerRect?.bottom - 25) + "px"; // 25px is because of padding bottom
    }, []);

    /* Hooks */

    // Alert Message
    const {
        alertMessageDisplay, setAlertMsg
    } = useAlertMessage({
        ...props,
        isFormSubmissionAttempted
    });

    // Company
    const { 
        companyId, companyDetails,
        isTypingAccountCode,
        isEveryInputValid: isEveryInputValid_company,
        display: companyInputDisplay,
        isAnyInputChanged: isAnyInputChanged_company
    } = useCompanyInputs({
        ...props, 
        isFormSubmissionAttempted, 
    });

    const { 
        productList: productListDetails,
        isEveryInputValid: isEveryInputValid_multiProduct,
        display: multiProductInputDisplay,
        isAnyInputChanged: isAnyInputChanged_multiProduct
    } = useMultiProductInputs({
        ...props, 
        isFormSubmissionAttempted, 
    })
    
    // Input Check
    let isEveryInputValid = (
        isEveryInputValid_company && isEveryInputValid_multiProduct
    )
    let isAnyInputChanged = isAnyInputChanged_company || isAnyInputChanged_multiProduct;

    // Submission
    const {
        submitIcon, submitText, submitAltText,
        handleSubmission
    } = useSubmission({
        ...props,

        isEveryInputValid, isAnyInputChanged,

        // referenceValue, 
        // productCode, 
        companyId,

        companyDetails, 
        productListDetails,

        isFormSubmissionAttempted, setFormSubmissionStatus,
        setAlertMsg
    })

    // Handle Page Exit
    const {
        handleHideFormPage,
        pageExitModal
    } = useOnPageExit({
        ...props,
        handleSubmission,
        isAnyInputChanged,
        isEveryInputValid
    });

    return (
        <DashboardLayout
            headerTitle={pageHeaderTitle}
            
            onClose={isAnyInputChanged && handleHideFormPage}
            isHeaderCloseIconVisible

            bodyClassName={"recursiveBillingSetupAccountUpdate"}
            body={(
                <React.Fragment>
                    {/* Page Exit Alert */}
                    {pageExitModal}

                    <div id={headerID} className="recursiveBillingSetupAccountUpdate-subHeader d-flex justify-content-between">
                        {/* Title */}
                        <span className={"recursiveBillingSetupAccountUpdate-subHeader-title"}>{isEditing? "Update Info": "Insert Info"}</span>

                        {/* Action */}
                        <Button
                            className={"recursiveBillingSetupAccountUpdate-subHeader-action"}
                            handleOnClick={handleSubmission}
                            isDecoration_transparentDarkGreyBorder
                        >
                            <div className={"d-flex flex-column align-items-center justify-content-center"}>
                                {isLoading? (
                                    <Spinner size={0} isLeftMarginOptional />
                                ):(
                                    <img
                                        src={submitIcon}
                                        alt={submitAltText}
                                        className={"recursiveBillingSetupAccountUpdate-subHeaderAction-icon"}
                                    />
                                )}
                                <div className={"recursiveBillingSetupAccountUpdate-subHeaderAction-text"}>
                                    {submitText}
                                </div>
                            </div>
                        </Button>
                    </div>

                    <div id={inputWrapperID} className="recursiveBillingSetupAccountUpdate-inputWrapper">
                        {/* Alert Error Messages */}
                        {alertMessageDisplay}
                        
                        <div className={"d-flex flex-column h-100"}>
                            <div className={"input-wrapper__left-section"}>
                                {/* Company Info */}
                                {companyInputDisplay}

                                {/* Product Info */}
                                {multiProductInputDisplay}
                            </div>
                        </div>
                    </div>
                </React.Fragment>
            )}

            updateParentState_visiblity={props.updateParentState_visiblity}
        />
    );
}